import { Controller } from "@hotwired/stimulus";
import EditorJs from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import Image from "@editorjs/image";
import RawTool from '@editorjs/raw';
import Delimiter from '@coolbytes/editorjs-delimiter'
import EditorjsList from '@editorjs/list';

export default class extends Controller {
  connect() {
    this.editor = new EditorJs({
      holder: this.element,
      tools: {
        header: Header,
        paragraph: Paragraph,
        image: {
          class: Image,
          config: {
            endpoints: {
              byFile: "/editorjs/upload_image",
            },
          },
        },
        raw: RawTool,
        delimiter: Delimiter,
        list: {
          class: EditorjsList,
          inlineToolbar: true,
          config: {
            defaultStyle: 'unordered'
          },
        },
      }
    })
  }
}
